export const statusOptions = ['IN_PROGRESS', 'PENDING', 'CONCLUDED', 'REJECTED'] as const;
export type TTaskStatus = (typeof statusOptions)[number];

export const sourceOptions = ['AUTOMATIONS', 'INTEGRATIONS', 'EXTENSIONS', 'SCRIPTS', 'EXTERNAL'] as const;
export type TTaskSource = (typeof sourceOptions)[number];

export const typeOptions = ['ERROR', 'WARNING'] as const;
export type TTaskType = (typeof typeOptions)[number];

export interface TTaskItem {
  id: string;
  createdAt: string;
  completedAt?: string;
  completedByUserId?: string;
  assignedUserId?: string;
  status?: TTaskStatus;
  source?: TTaskSource;
  type?: TTaskType;
  message?: string;
  organizationId?: string;
}

export interface TFullTaskData {
  id: string;
  createdAt: string;
  completedAt?: string;
  completedByUserId?: string;
  assignedUserId?: string;
  status?: TTaskStatus;
  source?: TTaskSource;
  type?: TTaskType;
  message?: string;
  details?: object;
  comments?: CCommentData[];
  organizationId?: string;
}

export interface CCommentData {
  id: string;
  content: string;
  createdByUserId: string;
  createdAt: string;
  updatedAt: string;
}

export interface TCreateCommentPayload {
  content: string;
}

export interface TUpdateCommentPayload {
  content: string;
  organizationId?: string;
}
